<template>
    <v-app>
        <v-container fluid>
            <template v-if="$insertAccess($route.path)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel" >
                                <v-expansion-panel>
                                    <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header"><span>{{ isEntryMode ? "Run Depreciation" : "Update Depreciation" }}</span></v-expansion-panel-title>
                                        <v-expansion-panel-text> 
                                            <v-row class="py-2 px-2 no-gutters justify-space-around">
                                                
                                                <v-col lg="3" md="4" cols="12">
                                                    <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="period_type.value.value"
                                                    :error-messages="period_type.errorMessage.value"
                                                    clearable
                                                    :items="periodTypeList"
                                                    :item-title="item => `${item.text}`"   
                                                    autocomplete="off"   
                                                    item-value="value"
                                                    
                                                        :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                        <template #label>
                                                            Period Type <span class="text-red-accent-4">*</span>
                                                        </template> 
                                                    </v-autocomplete>

                                                </v-col>
                                                
                                                <v-col lg="3" md="4" cols="12">
                                                    <v-date-input
                                                    input-format="dd/mm/yyyy"
                                                    label="Start Date"
                                                    density="compact"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="start_date.value.value"
                                                    :error-messages="start_date.errorMessage.value"
                                                    autocomplete="off"
                                                    :disabled="dateDisabled"
                                                    clearable
                                                    ></v-date-input>
                                                </v-col>

                                                <v-col lg="3" md="4" cols="12">
                                                    <v-date-input
                                                    input-format="dd/mm/yyyy"
                                                    label="End Date"
                                                    density="compact"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="end_date.value.value"
                                                    :error-messages="end_date.errorMessage.value"
                                                    autocomplete="off"
                                                    :disabled="dateDisabled"
                                                    clearable
                                                    ></v-date-input>
                                                </v-col>

                                                <v-col lg="3" md="4" cols="12">
                                                    <v-date-input
                                                    input-format="dd/mm/yyyy"
                                                    label="Depreciation Date"
                                                    density="compact"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="depreciation_date.value.value"
                                                    :error-messages="depreciation_date.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                    >
                                                        <template #label>
                                                            Depreciation Date <span class="text-red-accent-4">*</span>
                                                        </template> 
                                                    </v-date-input>
                                                </v-col>
                                            </v-row>

                                            <v-divider></v-divider>
                                            <v-card-actions>
                                                <v-row class="pt-2">
                                                    <v-col cols="8">
                                                        <v-textarea
                                                        label="Remarks"
                                                        density="compact"
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        v-model="remarks.value.value"
                                                        :error-messages="remarks.errorMessage.value"
                                                        autocomplete="off"
                                                        rows="3"
                                                        clearable
                                                        ></v-textarea>
                                                    </v-col>
                                                    
                                                    <v-col cols="4">
                                                        <v-layout class="justify-end">
                                                        <v-btn
                                                            class="bg-grey-darken-1 me-2"
                                                            variant="flat"
                                                            @click="submitForm(0)"
                                                            >DRAFT</v-btn
                                                        >
                                                        <v-btn
                                                            class="bg-primary"
                                                            variant="flat"
                                                            @click="submitForm(1)"
                                                            >POST</v-btn
                                                        >
                                                        </v-layout>
                                                    </v-col>
                                                </v-row>
                                            </v-card-actions>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
            </v-container>
        </v-app>
</template>

<script>

import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router'; 
import { fileServerUrl } from "@/store/api";
import formattedDate from '@/plugins/dateFormatter';

export default {
        components: {},
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            search: "",
            data: {},
            dateDisabled: false,
            periodTypeList: [
                { text: "Monthly", value: "monthly" },
                { text: "Quarterly", value: "quarterly" },
                { text: "Custom", value: "custom" },
                { text: "Financial Year", value: "financial_year" }
            ]
        }),

        watch: {
            'period_type.value.value'(val){
                if(val === "financial_year") {
                    this.dateDisabled = true
                    return;
                }
                this.dateDisabled = false
            }
        },
        created(){},
        computed:{},

        methods: {
            resetForm() {
                this.data = {};
            },
        },

        setup() {
            const { handleSubmit, resetForm } = useForm({
                validationSchema: yup.object({
                    depreciation_date: yup.date().required("Start Date is required").label("Start Date"),
                    period_type: yup.string().required("Start Date is required").label("Start Date")
                }),
            });

            const period_type = useField('period_type');
            const start_date = useField('start_date');
            const end_date = useField('end_date');
            const depreciation_date = useField('depreciation_date');
            const status = useField('status');
            const remarks = useField('remarks');
            
            const errorMessages  = ref('');
            const loading  = ref('');
            const isEntryMode = ref(true);

            const store = useStore();
            const router = useRouter();

            const currentStatus = ref(0);

            const submitForm = (status) => {
                currentStatus.value = status;
                submit();
            };

            const submit = handleSubmit((values) => { 
                const formData = new FormData();
                values.start_date  = formattedDate(start_date.value.value);
                values.end_date = formattedDate(start_date.value.value);
                values.depreciation_date = formattedDate(depreciation_date.value.value);

                Object.keys(values).forEach((key) => {
                    formData.append(key, values[key] || "");
                });

                formData.append('status', currentStatus.value);

                store.dispatch("saveUpdateAssetDepreciation", formData) 
                    .then((response) => {  
                        resetForm();
                        toast.success(response.data.message, {
                            timeout: 3000,
                        });
                        store.dispatch("getAssetDepreciationsList")
                        setTimeout(() => {  
                            router.push({ name: "depreciation-records" });
                        }, 2000);
                    })
                    .catch((error) => { 
                        loading.value = false;
                        toast.error(error.response.data.message);      
                    })
            })
            return {
            submit,
            submitForm,
            name,
            period_type,
            start_date,
            end_date,
            depreciation_date,
            remarks,
            status,
            errorMessages,
            isEntryMode,
            resetForm,
            loading
            }
        },
        mounted() {

            // if (this.$store.getters.getEditingAssetDepreciation) {
            //     const data = this.$store.getters.getEditingAssetDepreciation;
            //     this.$store.commit('SET_LOADING', { color: 'primary' });
                
            //     this.isEntryMode = false;

            //     this.period_type.value.value = data.period_type;
            //     this.start_date.value.value = data.start_date;
            //     this.end_date.value.value = data.end_date;
            //     this.depreciation_date.value.value = data.depreciation_date;
            //     this.remarks.value.value = data.remarks;

            //     this.$store.commit('UNSET_LOADING');
            // }
        },
        beforeUnmount() {
            // this.$store.commit('UNSET_EDITING_ASSET_REGISTRATION');
        }
    }
</script>